module.exports = __webpack_public_path__ + "static/img/100-V1.2aa226a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loader/100 260/100-V1.gif
// module id = LV3y
// module chunks = 7